<template>
  <div style="height: 100%">
    <!-- 页面骨架：筛选区(状态/名称/编码/地市/区县 + 刷新快照按钮) + ve-table列表 + 分页
         数据读欠款快照表(定时任务每小时自动刷新)，刷新按钮手动触发重建并提示欠款商户数 -->
    <div style="display: flex; width: 100%">
      <div style="width: 95%; height: 40px">
        <el-row class="filter-bar" ref="filterBar">
          <el-select size="mini" v-model="formDatas.asStatus" clearable placeholder="商户状态"
            style="width: 130px" @change="partserch">
            <el-option v-for="item in statusOptions" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
          <el-input v-model="formDatas.asName" style="width: 150px;" size="mini"
            placeholder="商户名称" clearable></el-input>
          <el-input v-model="formDatas.asNumber" style="width: 150px;" size="mini"
            placeholder="商户编码" clearable></el-input>
          <el-select size="mini" v-model="formDatas.ascId" clearable placeholder="地市" style="width: 120px;"
            @change="cityChange">
            <el-option v-for="item in cityListData" :key="item.ascId" :label="item.ascName"
              :value="item.ascId"></el-option>
          </el-select>
          <el-select size="mini" v-if="formDatas.ascId" v-model="formDatas.ascdId" clearable placeholder="区县"
            style="width: 120px;" @change="partserch">
            <el-option v-for="item in districtListData" :key="item.ascdId" :label="item.ascdName"
              :value="item.ascdId"></el-option>
          </el-select>
          <div class="filter-actions">
          <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
            style="">搜索</el-button>
          <el-button type="warning" size="mini" icon="el-icon-refresh" :loading="refreshing" @click="refreshDebt"
            style="">刷新欠款数据</el-button>
          </div>
        </el-row>
      </div>
    </div>
    <div class="tablemain">
      <!-- 合计统计条：后端 item 返回（与列表同筛选、不受分页影响）：欠款商户数+四类构成+合计+快照时间 -->
      <div v-if="statsItem" class="debt-stats">
        <div class="debt-stats__cell">
          <div class="debt-stats__label">欠款商户</div>
          <div class="debt-stats__value">{{ statsItem.debtShopCount != null ? statsItem.debtShopCount : 0 }} 家</div>
        </div>
        <div class="debt-stats__cell">
          <div class="debt-stats__label">撤销账单欠款</div>
          <div class="debt-stats__value">{{ statsItem.debtRevokeYuan || "0.00" }} 元</div>
        </div>
        <div class="debt-stats__cell">
          <div class="debt-stats__label">发票补差欠款</div>
          <div class="debt-stats__value">{{ statsItem.debtReceiptYuan || "0.00" }} 元</div>
        </div>
        <div class="debt-stats__cell">
          <div class="debt-stats__label">平台垫资提现欠款</div>
          <div class="debt-stats__value">{{ statsItem.debtWithdrawPublicYuan || "0.00" }} 元</div>
        </div>
        <div class="debt-stats__cell">
          <div class="debt-stats__label">商城订单退款欠款</div>
          <div class="debt-stats__value">{{ statsItem.debtOrderRefundYuan || "0.00" }} 元</div>
        </div>
        <div class="debt-stats__cell debt-stats__cell--total">
          <div class="debt-stats__label">欠款合计</div>
          <div class="debt-stats__value debt-stats__value--total">{{ statsItem.debtTotalYuan || "0.00" }} 元</div>
        </div>
        <div class="debt-stats__time" v-if="statsItem.createtime">
          快照时间：{{ statsItem.createtime }}
        </div>
      </div>
      <div class="tablecss" v-loading="tableLoading" element-loading-background="rgba(255, 255, 255, 0.9)"
        element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading">
        <div style="width: 100%">
          <ve-table ref="vetable" :columns="columns" :table-data="tableData" :max-height="tableHight"
            :border-x="true" :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
            row-key-field-name="asdId" style="width: 100%" />
          <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
        </div>
        <div class="table-pagination">
          <ve-pagination :total="totalCount" :page-index="formDatas.currentPage" :page-size="formDatas.pageSize"
            :page-size-option="[25, 50, 80, 100, 300, 500]" @on-page-number-change="pageNumberChange"
            @on-page-size-change="pageSizeChange" />
        </div>
      </div>
    </div>

    <!-- 充值还款弹窗：线下收款录入，余额覆盖欠款时后端自动结清 -->
    <el-dialog title="商户充值-线下收款（欠款清账）" :visible.sync="rechargeDialog" width="460px"
      :close-on-click-modal="false">
      <el-form ref="rechargeForm" :model="rechargeForm" :rules="rechargeRules" label-width="90px" size="small">
        <el-form-item label="商户">
          <span style="font-weight: bold">{{ rechargeRow.asName || "-" }}</span>
          <span style="color: #909399; font-size: 12px; margin-left: 8px">
            当前欠款 {{ rechargeRow.debtTotalYuan || "0.00" }} 元 / 余额 {{ rechargeRow.asaBalanceYuan || "0.00" }} 元</span>
        </el-form-item>
        <el-form-item label="充值金额" prop="rechargeMoney">
          <el-input v-model="rechargeForm.rechargeMoney" placeholder="请输入金额（元，至少一元）"
            style="width: 260px"></el-input>
        </el-form-item>
        <el-form-item label="收款凭证" prop="rechargeDes">
          <el-input v-model="rechargeForm.rechargeDes" type="textarea" :rows="3" maxlength="500" show-word-limit
            placeholder="线下打款流水号 / 进账单描述等（选填）"></el-input>
        </el-form-item>
        <div style="color: #909399; font-size: 12px; margin: -6px 0 6px 90px">
          充值入账后，若余额足以覆盖欠款将自动结清，超出部分留存为商户可提现余额
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="rechargeDialog = false">取 消</el-button>
        <el-button size="small" type="primary" :loading="rechargeSubmitting" @click="submitRecharge">确认录入</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { calcTableHeight } from "../../utils/tableHeight.js";
import {
  getAjefShopDebtList,
  updateAjefShopDebtRefresh,
  addAjefShopRecharge,
  getAjefShopCityList,
  getAjefShopCityDistrictList,
} from "../../api/api";
import ClampCell from "../../components/ClampCell.vue";

// 商户状态枚举(与商户列表页口径一致)
const STATUS_OPTIONS = [
  { value: 1, label: "待提交" },
  { value: 2, label: "待审核" },
  { value: 3, label: "审核通过" },
  { value: 4, label: "审核驳回" },
  { value: 5, label: "撤销审核" },
  { value: 6, label: "禁用商户" },
];

export default {
  name: "shopDebt",
  components: { ClampCell },
  data() {
    return {
      tableLoading: false,
      refreshing: false,
      totalCount: 0,
      tableHight: 520,
      tableData: [],
      // 合计统计（后端 item：与列表同筛选、不受分页影响的聚合行）
      statsItem: null,
      cityListData: [],
      districtListData: [],
      statusOptions: STATUS_OPTIONS,
      // 充值还款弹窗
      rechargeDialog: false,
      rechargeSubmitting: false,
      rechargeRow: {}, // 当前操作的欠款商户行（弹窗内回显名称/欠款/余额）
      rechargeForm: {
        rechargeMoney: "",
        rechargeDes: "",
      },
      rechargeRules: {
        rechargeMoney: [
          { required: true, message: "请输入充值金额", trigger: "blur" },
          {
            // 数字且≥1元（后端同口径校验：分值≥100）
            pattern: /^([1-9]\d*|0\.\d{1,2}|[1-9]\d*\.\d{1,2})$/,
            message: "金额需为数字且至少一元",
            trigger: "blur",
          },
        ],
      },
      formDatas: {
        asStatus: "",
        asName: "",
        asNumber: "",
        ascId: "",
        ascdId: "",
        currentPage: 1,
        pageSize: 25,
      },
      cellStyleOption: {
        headerCellClass: ({ rowIndex }) => {
          if (rowIndex === 0) {
            return "table-header-cell-class";
          }
        },
      },
      columns: [
        {
          field: "",
          key: "a",
          title: "序号",
          width: 50,
          fixed: "left",
          align: "center",
          renderBodyCell: ({ rowIndex }, h) => {
            return ++rowIndex;
          },
        },
        {
          field: "asName",
          key: "asName",
          title: "商户名称",
          width: 260,
          align: "center",
          // 名称可能较长：4行截断，超出时 hover 预览
          renderBodyCell: ({ row }, h) => {
            return h(ClampCell, { props: { text: row.asName || "-" } });
          },
        },
        {
          field: "asNumber",
          key: "asNumber",
          title: "商户编码",
          width: 140,
          align: "center",
          renderBodyCell: ({ row }) => row.asNumber || "-",
        },
        {
          field: "asCity",
          key: "asCity",
          title: "地市",
          width: 160,
          align: "center",
          renderBodyCell: ({ row }) => row.asCity || "-",
        },
        {
          field: "asStatus",
          key: "asStatus",
          title: "商户状态",
          width: 90,
          align: "center",
          renderBodyCell: ({ row }, h) => {
            const map = {
              1: { text: "待提交", type: "" },
              2: { text: "待审核", type: "danger" },
              3: { text: "审核通过", type: "success" },
              4: { text: "审核驳回", type: "danger" },
              5: { text: "撤销审核", type: "info" },
              6: { text: "禁用商户", type: "danger" },
            };
            const tag = map[row.asStatus] || { text: "-", type: "info" };
            return h("el-tag", { props: { type: tag.type, size: "mini" } }, tag.text);
          },
        },
        {
          field: "asaBalanceYuan",
          key: "asaBalanceYuan",
          title: "当前余额(元)",
          width: 110,
          align: "center",
          renderBodyCell: ({ row }) => row.asaBalanceYuan || "0.00",
        },
        {
          field: "debtRevokeYuan",
          key: "debtRevokeYuan",
          title: "撤销账单欠款(元)",
          width: 120,
          align: "center",
          renderBodyCell: ({ row }) => row.debtRevokeYuan || "0.00",
        },
        {
          field: "debtReceiptYuan",
          key: "debtReceiptYuan",
          title: "发票补差欠款(元)",
          width: 120,
          align: "center",
          renderBodyCell: ({ row }) => row.debtReceiptYuan || "0.00",
        },
        {
          field: "debtWithdrawPublicYuan",
          key: "debtWithdrawPublicYuan",
          title: "平台垫资提现欠款(元)",
          width: 130,
          align: "center",
          renderBodyCell: ({ row }) => row.debtWithdrawPublicYuan || "0.00",
        },
        {
          field: "debtOrderRefundYuan",
          key: "debtOrderRefundYuan",
          title: "商城订单分账退款欠款(元)",
          width: 150,
          align: "center",
          renderBodyCell: ({ row }) => row.debtOrderRefundYuan || "0.00",
        },
        {
          field: "debtTotalYuan",
          key: "debtTotalYuan",
          title: "欠款合计(元)",
          width: 120,
          align: "center",
          fixed: "right",
          renderBodyCell: ({ row }, h) => {
            // 合计列红色加粗：列表按欠款合计倒序，此列为核心指标
            return h("span", { style: { color: "#F56C6C", fontWeight: "bold" } }, row.debtTotalYuan || "0.00");
          },
        },
        {
          field: "operation",
          key: "operation",
          title: "操作",
          width: 90,
          align: "center",
          fixed: "right",
          renderBodyCell: ({ row }, h) => {
            // 充值还款：线下收到商户打款后录入，余额覆盖欠款时后端同事务自动结清
            return h("el-button", {
              props: { type: "text", size: "mini" },
              style: { color: "#E6A23C", padding: "0" },
              on: { click: () => this.openRecharge(row) },
            }, "充值还款");
          },
        },
      ],
    };
  },
  activated() {
    this.watchFlag = true;
    this.$nextTick(() => {
      this.windheight = this.$store.state.windheight;
      this.tableHight = calcTableHeight(this, this.windheight, 210);
    });
  },
  watch: {
    "$store.state.windheight"(val) {
      this.$nextTick(() => {
        if (this.watchFlag) {
          this.tableHight = calcTableHeight(this, val, 210);
        }
      });
    },
  },
  deactivated() {
    this.watchFlag = false;
  },
  created() {
    this.windheight = this.$store.state.windheight;
    this.tableHight = calcTableHeight(this, this.windheight, 210);
    this.loadCityList();
    this.getList();
  },
  methods: {
    getList() {
      this.tableLoading = true;
      getAjefShopDebtList(this.formDatas).then((res) => {
        this.tableLoading = false;
        if (!res) {
          return;
        }
        this.tableData = res.data || [];
        this.totalCount = res.total || 0;
        // 合计统计：与列表同筛选的聚合行（欠款商户数/四类构成/合计/快照时间）
        this.statsItem = res.item || null;
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    partserch() {
      this.formDatas.currentPage = 1;
      this.getList();
    },
    pageNumberChange(pageIndex) {
      this.formDatas.currentPage = pageIndex;
      this.getList();
    },
    pageSizeChange(pageSize) {
      this.formDatas.pageSize = pageSize;
      this.formDatas.currentPage = 1;
      this.getList();
    },
    // 地市级联：切换地市时清空区县并加载区县列表
    cityChange(ascId) {
      this.formDatas.ascdId = "";
      this.districtListData = [];
      if (ascId) {
        this.loadDistrictList(ascId);
      }
      this.partserch();
    },
    loadCityList() {
      getAjefShopCityList({}).then((res) => {
        if (res) {
          this.cityListData = res.data || [];
        }
      });
    },
    loadDistrictList(ascId) {
      getAjefShopCityDistrictList({ ascId }).then((res) => {
        if (res) {
          this.districtListData = res.data || [];
        }
      });
    },
    // 手动刷新欠款快照：后端整表重建(定时任务每小时也会刷一次)，完成后提示欠款商户数并重查当前页
    refreshDebt() {
      if (this.refreshing) return;
      this.refreshing = true;
      updateAjefShopDebtRefresh().then((res) => {
        this.refreshing = false;
        if (!res) return;
        this.$message({
          type: "success",
          message: "刷新完成，当前欠款商户 " + (res.data != null ? res.data : 0) + " 家",
        });
        this.getList();
      }).catch(() => {
        this.refreshing = false;
      });
    },
    // ===== 充值还款（线下收款录入，欠款清账）=====
    openRecharge(row) {
      this.rechargeRow = row;
      this.rechargeForm = { rechargeMoney: "", rechargeDes: "" };
      this.rechargeDialog = true;
      this.$nextTick(() => {
        if (this.$refs.rechargeForm) {
          this.$refs.rechargeForm.clearValidate();
        }
      });
    },
    submitRecharge() {
      if (this.rechargeSubmitting) return;
      this.$refs.rechargeForm.validate((valid) => {
        if (!valid) return;
        // 资金操作二次确认：回显商户与金额
        this.$confirm(
          "确认已线下收到 " + this.rechargeRow.asName + " 充值 " + this.rechargeForm.rechargeMoney + " 元吗？",
          "确认录入充值",
          { type: "warning", confirmButtonText: "确认", cancelButtonText: "取消" }
        ).then(() => {
          this.doRechargeSubmit();
        }).catch(() => {});
      });
    },
    doRechargeSubmit() {
      this.rechargeSubmitting = true;
      addAjefShopRecharge({
        asId: this.rechargeRow.asId,
        rechargeMoney: this.rechargeForm.rechargeMoney,
        rechargeDes: this.rechargeForm.rechargeDes || "",
      }).then((res) => {
        this.rechargeSubmitting = false;
        if (!res) return;
        const data = res.data || {};
        this.rechargeDialog = false;
        // 按后端清账结果分文案：全部结清 / 部分冲抵 / 无欠款直接入余额
        if (data.settled && !data.debtRemaining) {
          this.$message.success("充值成功，欠款已全部结清（本次冲抵 " + (data.settledMoneyYuan || "0.00") + " 元）");
        } else if (data.settled) {
          this.$message.success("充值成功，冲抵欠款 " + (data.settledMoneyYuan || "0.00") + " 元");
        } else {
          this.$message.success("充值成功，已入商户余额");
        }
        this.getList();
      }).catch(() => {
        this.rechargeSubmitting = false;
      });
    },
  },
};
</script>

<style>
.ve-table-container {
  height: auto !important;
}
</style>

<style scoped>
/* 合计统计条：筛选区下、表格上一行紧凑卡片（金额红色系突出，合计最重）；
   高度紧凑控制在 ~50px，表格 maxHeight 已同步多预留 70px（见 js tableHight 计算）防分页被挤出视口 */
.debt-stats {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 28px;
  margin: 8px 25px 0;
  padding: 8px 16px;
  background: #fdf7f2;
  border: 1px solid #f5dcc8;
  border-radius: 4px;
}

.debt-stats__cell {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.debt-stats__label {
  font-size: 12px;
  color: #909399;
}

.debt-stats__value {
  font-size: 15px;
  font-weight: bold;
  color: #e6a23c;
  font-variant-numeric: tabular-nums;
}

.debt-stats__value--total {
  font-size: 17px;
  color: #f56c6c;
}

.debt-stats__time {
  margin-left: auto;
  font-size: 12px;
  color: #c0c4cc;
}
</style>
